import { render, staticRenderFns } from "./FullScreenImage.vue?vue&type=template&id=192670c5&scoped=true&"
import script from "./FullScreenImage.vue?vue&type=script&lang=js&"
export * from "./FullScreenImage.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenImage.vue?vue&type=style&index=0&id=192670c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192670c5",
  null
  
)

export default component.exports